var React = require('react');

function ArrowRightLongSharpLight21 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.6469 8.35314L16 8.00001L15.6469 7.64689L11.1469 3.14689L10.7937 2.79376L10.0844 3.50001L10.4375 3.85314L14.0844 7.50001H0.5H0V8.50001H0.5H14.0844L10.4406 12.1469L10.0844 12.5L10.7906 13.2063L11.1438 12.8531L15.6438 8.35314H15.6469Z","fill":"white"}));
}

ArrowRightLongSharpLight21.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRightLongSharpLight21;

ArrowRightLongSharpLight21.default = ArrowRightLongSharpLight21;
